export const branches = [
  "Granger",
  "Mishawaka",
  "Elkhart",
  "Coloma",
  "Fort Wayne - Store",
  "Three Oaks",
  "Edgerton",
  "Kendallville",
  "Cromwell",
  "Delton",
  "LaPorte",
  "Roseland",
  "Adrian",
  "Shipshewana",
  "Eau Claire",
  "Schoolcraft",
];

export const getCheckedAddress = (setter, userSelected) => {
  return fetch(`/api/cloud/getAddressValidate?user=${userSelected}`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAdcUsers = (setter) => {
  return fetch(`/api/profile/portal/getUsers?key=0a9kdk0dsa3912j3812jada9821`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const sendShareCode = (code) => {
  return fetch(`/api/profile/send/sharecode?code=${code}&key=33213`)
    .then((response) => response.json())
    .then((responseJson) => {
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const countInvalidAll = (setter, userSelected) => {
  return fetch(`/api/cloud/countInvalidAll?user=${userSelected}`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const countValidAll = (setter, userSelected) => {
  return fetch(`/api/cloud/countValidAll?user=${userSelected}`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAllUsers = (setter) => {
  return fetch(`/api/user/getAllUsers`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

// Awaitable variant of getAllUsers: resolves with the user list or throws,
// so callers can actually surface load failures.
export const fetchAllUsers = async () => {
  const response = await fetch(`/api/user/getAllUsers`);
  if (!response.ok) {
    throw new Error("Failed to load users");
  }
  return response.json();
};

export const getAllOnlineUsers = (setter) => {
  return fetch(`/api/user/getAllUsers/online`)
    .then((response) => response.json())
    .then((responseJson) => {
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getUser = (setter, id) => {
  return fetch(`/api/user/getUser?id=${id}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson[0]);
    })
    .catch((error) => {
      //console.error(error);
    });
};

// Awaitable variant of getUser: resolves with the user document or null
// when the user has no record yet / the request fails.
export const fetchUser = async (id) => {
  try {
    const response = await fetch(`/api/user/getUser?id=${id}`);
    const responseJson = await response.json();
    return responseJson[0] ?? null;
  } catch (error) {
    return null;
  }
};

// Awaitable role refresh. Resolves with the server's answer verbatim —
// including [] when the user has no roles or no record — so callers can
// fail closed. Rejects only when the server couldn't be reached at all.
export const fetchUserRoles = async (id) => {
  const response = await fetch(
    `/api/user/getUser/roles?id=${encodeURIComponent(id)}`
  );
  if (!response.ok) return [];
  const data = await response.json();
  return Array.isArray(data) ? data : [];
};

export const getUserFavorites = (setter, id) => {
  return fetch(`/api/user/getUser/favorites?id=${id}`)
    .then((response) => response.json())
    .then((responseJson) => {
      // console.log(responseJson);
      setter(responseJson);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getUserPins = (setter, id) => {
  return fetch(`/api/user/getUser/pins?id=${id}`)
    .then((response) => response.json())
    .then((responseJson) => {
      //console.log(responseJson);
      setter(responseJson);
    })
    .catch((error) => {
      //if nothing set to empty array
      setter([]);
      //console.error(error);
    });
};

export const updateUserRole = (id, type, role) => {
  return fetch(
    `/api/user/updateUserRole?id=${encodeURIComponent(
      id
    )}&type=${type}&role=${encodeURIComponent(role)}`
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to update role");
      }

      return response;
    })
    .catch((error) => {
      //console.error(error);
      throw error;
    });
};

export const setUserStatus = async (id, deactivated) => {
  const response = await fetch(`/api/user/setUserStatus`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id, deactivated }),
  });

  if (!response.ok) {
    throw new Error("Failed to update account status");
  }

  return response.json();
};

export const checkAdminRole = (user) => {
  return user.roles?.includes("Admin");
};

export const getUnassignedLeads = (set) => {
  return fetch(`/api/leads/getunassigned`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAllLeadsBranch = (set, branch) => {
  return fetch(`/api/leads/getall?branch=${branch}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAllLeads = (set) => {
  return fetch(`/api/leads/getall`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getLeadCounts = (set) => {
  return fetch(`/api/leads/getall/leadSummaryCount`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getLeadNoContact = (set) => {
  return fetch(`/api/leads/nocontact`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getLeadNoContactBranch = (set, branch) => {
  return fetch(`/api/leads/nocontact?branch=$branch}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson.length);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAverageLeadCompletionTime = (set) => {
  return fetch(`/api/leads/averagecompletion`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getAverageLeadCompletionTimeBranch = (set, branch) => {
  return fetch(`/api/leads/averagecompletion?branch=${branch}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getLeadConvertedSale = (set) => {
  return fetch(`/api/leads/data/tosale`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getLeadConvertedSaleBranch = (set, branch) => {
  return fetch(`/api/leads/data/tosale?branch=${branch}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getCompletedLeadsBranch = (set, branch) => {
  return fetch(`/api/leads/getall?completed=1&branch=${branch}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getCompletedUsersLeads = (set, userID) => {
  return fetch(`/api/leads/data/per/sales?userID=${userID}&type=2`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getDeletedUsersLeads = (set, userID) => {
  return fetch(`/api/leads/data/per/sales?userID=${userID}&type=3`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getOpenUsersLeads = (set, userID) => {
  return fetch(`/api/leads/data/per/sales?userID=${userID}&type=1`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

// /api/leads/data

export const getCompletedLeads = (set) => {
  return fetch(`/api/leads/getall?completed=1`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getDeletedLeadsBranch = (set, branch) => {
  return fetch(`/api/leads/getall?deleted=1&branch=${branch}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getDeletedLeads = (set) => {
  return fetch(`/api/leads/getall?deleted=1`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getManagerLeads = (set, id) => {
  return fetch(`/api/leads/getmanager?id=${id}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getSalesLeads = (set, id) => {
  return fetch(`/api/leads/getsales?id=${id}`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson);
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getChange = (set) => {
  return fetch(`/api/changelog/get`)
    .then((response) => response.json())
    .then((responseJson) => {
      set(responseJson.splice(1).reverse());
      return;
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getManagers = (setter) => {
  return fetch("/api/getUserID")
    .then((response) => response.json())
    .then(async (responseJson) => {
      await responseJson.recordset.push({
        UserID: 395,
        SalesRepCode: null,
        Name: "BLAKE UPHAM",
        EmailAddress: "blake.upham@bigclumber.com",
        JobTitle: "IT",
        Mobile: "574-218-5051",
        Branch: "Granger",
      });

      await responseJson.recordset.push({
        UserID: 1406,
        SalesRepCode: null,
        Name: "JOHN ROY",
        EmailAddress: "john.roy@bigclumber.com",
        JobTitle: "General Manager",
        Mobile: "260-215-7670",
        Branch: "Fort Wayne - Store",
      });

      // Jason Wehri isn't in the getsalesreps directory, so add him by hand
      // like the rows above. Guarded so he doesn't appear twice if the cloud
      // API starts returning him.
      if (
        !responseJson.recordset.some(
          (row) =>
            (row.EmailAddress || "").toLowerCase() ===
            "jason.wehri@bigclumber.com"
        )
      ) {
        responseJson.recordset.push({
          UserID: 342,
          SalesRepCode: null,
          Name: "JASON WEHRI",
          EmailAddress: "jason.wehri@bigclumber.com",
          JobTitle: "General Manager",
          Mobile: null,
          Branch: "Kendallville",
        });
      }

      // Brian Voorde is in the /users directory but not getsalesreps, so add
      // him by hand too. Same duplicate guard as above.
      if (
        !responseJson.recordset.some(
          (row) =>
            (row.EmailAddress || "").toLowerCase() === "brianv@bigclumber.com"
        )
      ) {
        responseJson.recordset.push({
          UserID: 63,
          SalesRepCode: null,
          Name: "BRIAN VOORDE",
          EmailAddress: "brianv@bigclumber.com",
          JobTitle: null,
          Mobile: null,
          Branch: "Elkhart",
        });
      }

      var array = [];
      var arrayLength = responseJson.recordset.length;
      for (var i = 0; i < arrayLength; i++) {
        if (
          responseJson.recordset[i].JobTitle === "General Manager" ||
          responseJson.recordset[i].Name === "STEVE WALDRON" ||
          responseJson.recordset[i].Name === "RYAN BECK" ||
          responseJson.recordset[i].Name === "SCOTT BUNKELMAN" ||
          responseJson.recordset[i].Name === "BLAKE UPHAM" ||
          responseJson.recordset[i].Name === "ALEC EVANS" ||
          responseJson.recordset[i].Name === "SCOTT FOLEY" ||
          responseJson.recordset[i].Name === "BEN CHAMBERS" ||
          responseJson.recordset[i].Name === "COURTNEY KAPTUR-03" ||
          responseJson.recordset[i].Name === "MIKE SENESAC JR" ||
          responseJson.recordset[i].Name === "JASON WEHRI" ||
          responseJson.recordset[i].Name === "BRIAN VOORDE" ||
          // Dakota Dunn covers Delton as Operations Manager, so he doesn't
          // pass the General Manager screen above.
          responseJson.recordset[i].Name === "DAKOTA DUNN"
        ) {
          if (responseJson.recordset[i].Name === "SCOTT FOLEY") {
            responseJson.recordset[i].Branch = "Western";
          }
          if (responseJson.recordset[i].Name === "BEN CHAMBERS") {
            responseJson.recordset[i].Branch = "Eastern";
          }
          // Kelly Parker stays out even if the directory lists her as a
          // General Manager again — Dakota Dunn took over the Delton leads.
          if (
            responseJson.recordset[i].Name !== "ANDY TOLCH" &&
            responseJson.recordset[i].Name !== "KELLY PARKER"
          ) {
            array.push(responseJson.recordset[i]);
          }
        }
      }
      setter(array);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getWindowDoorUsers = (setter) => {
  return fetch("/api/getUserID")
    .then((response) => response.json())
    .then((responseJson) => {
      var array = [];
      var arrayLength = responseJson.recordset.length;
      for (var i = 0; i < arrayLength; i++) {
        if (
          responseJson.recordset[i].Name === "AMANDA ABEYTA" ||
          responseJson.recordset[i].Name === "CHRISTY CIULA" ||
          responseJson.recordset[i].Name === "GAIE LYNNE LEER" ||
          responseJson.recordset[i].Name === "KORY SHEDD" ||
          responseJson.recordset[i].Name === "KURT GIBSON" ||
          responseJson.recordset[i].Name === "BLAKE UPHAM" ||
          responseJson.recordset[i].Name === "JOE LEICHTMAN"
        ) {
          array.push(responseJson.recordset[i]);
        }
      }
      setter(array);
    })
    .catch((error) => {
      //console.error(error);
    });
};

// export const getUserBranch = (user) => {
//   return fetch("/api/getUserID")
//     .then((response) => response.json())
//     .then((responseJson) => {
//       var array = [];
//       var arrayLength = responseJson.recordset.length;
//       for (var i = 0; i < arrayLength; i++) {
//         if (responseJson.recordset[i].Name === user.name.toUpperCase()) {
//           return responseJson.recordset[i].Branch;
//         }
//       }
//       return "No Branch";
//     })
//     .catch((error) => {
//       console.error(error);
//     });
// };

export const getSalesTeam = (setter) => {
  return fetch("/api/getUserID")
    .then((response) => response.json())
    .then((responseJson) => {
      var array = [];
      var arrayLength = responseJson.recordset.length;
      for (var i = 0; i < arrayLength; i++) {
        if (
          responseJson.recordset[i].JobTitle === "Inside Sales" ||
          responseJson.recordset[i].JobTitle === "Outside Sales"
        ) {
          if (responseJson.recordset[i].Name !== "JACK EARLEY") {
            array.push(responseJson.recordset[i]);
          }
        }
      }
      setter(array);
    })
    .catch((error) => {
      //console.error(error);
    });
};

// Scott and James take web leads for any location, so every manager's assign
// dropdown offers them even though they're based in Roseland.
const ASSIGNABLE_FROM_ANY_BRANCH = ["SCOTT BUNKELMAN", "JAMES TAYLOR"];

const checkJobTitlesWebLeads = (jobTitle, name) => {
  if (
    jobTitle === "Inside Sales" ||
    jobTitle === "Outside Sales" ||
    jobTitle === "Kitchen Department Coordinator" ||
    jobTitle === "Cabinet Sales" ||
    jobTitle === "Installed Sales" ||
    jobTitle === "Installed Service Tech" ||
    jobTitle === "Estimating" ||
    jobTitle === "General Manager" ||
    name === "BLAKE UPHAM" ||
    name === "LISA LASKOWSKI" ||
    name === "BRIDGET PATZER" ||
    name === "JAMES TAYLOR"
  ) {
    return true;
  }
  return false;
};

export const getSalesTeamForLocation = (setter, branch) => {
  const easternBranches = [
    "Adrian",
    "Edgerton",
    "Fort Wayne - Store",
    "Kendallville",
    "Cromwell",
    "Delton",
    "Schoolcraft",
    "Shipshewana",
  ];
  const westernBranches = [
    "Roseland",
    "Elkhart",
    "Three Oaks",
    "Coloma",
    "Mishawaka",
    "Eau Claire",
    "Granger",
    "LaPorte",
  ];

  return fetch("/api/getUserID")
    .then((response) => response.json())
    .then((responseJson) => {
      // These people aren't in the getsalesreps directory, so add them by
      // hand like the rows in getManagers above. Guarded so they don't appear
      // twice if the cloud API starts returning them.
      [
        {
          UserID: 726,
          SalesRepCode: null,
          Name: "JAMES TAYLOR",
          EmailAddress: "james.taylor@bigclumber.com",
          JobTitle: null,
          Mobile: null,
          Branch: "Roseland",
        },
        {
          UserID: 315,
          SalesRepCode: null,
          Name: "LISA LASKOWSKI",
          EmailAddress: "lisal@bigclumber.com",
          JobTitle: null,
          Mobile: null,
          Branch: "Granger",
        },
        {
          UserID: 470,
          SalesRepCode: null,
          Name: "BRIDGET PATZER",
          EmailAddress: "bridget.patzer@bigclumber.com",
          JobTitle: null,
          Mobile: null,
          Branch: "Granger",
        },
      ].forEach((person) => {
        if (
          !responseJson.recordset.some(
            (row) =>
              (row.EmailAddress || "").toLowerCase() ===
              person.EmailAddress.toLowerCase()
          )
        ) {
          responseJson.recordset.push(person);
        }
      });

      var array = [];
      var arrayLength = responseJson.recordset.length;

      for (var i = 0; i < arrayLength; i++) {
        switch (branch) {
          case "Eastern":
            if (
              (checkJobTitlesWebLeads(
                responseJson.recordset[i].JobTitle,
                responseJson.recordset[i].Name
              ) &&
                easternBranches.includes(responseJson.recordset[i].Branch)) ||
              ASSIGNABLE_FROM_ANY_BRANCH.includes(responseJson.recordset[i].Name)
            ) {
              array.push(responseJson.recordset[i]);
            }
            break;
          case "Western":
            if (
              (checkJobTitlesWebLeads(
                responseJson.recordset[i].JobTitle,
                responseJson.recordset[i].Name
              ) &&
                westernBranches.includes(responseJson.recordset[i].Branch)) ||
              ASSIGNABLE_FROM_ANY_BRANCH.includes(responseJson.recordset[i].Name)
            ) {
              array.push(responseJson.recordset[i]);
            }
            break;
          default:
            if (
              (checkJobTitlesWebLeads(
                responseJson.recordset[i].JobTitle,
                responseJson.recordset[i].Name
              ) &&
                responseJson.recordset[i].Branch === branch) ||
              ASSIGNABLE_FROM_ANY_BRANCH.includes(responseJson.recordset[i].Name) ||
              responseJson.recordset[i].Name === "ASHLEY SMITTENDORF"
            ) {
              array.push(responseJson.recordset[i]);
            }
            break;
        }
      }
      setter(array);
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getNodeProfileSalesTeamForLocation = (setter, branch) => {
  const easternBranches = [
    "Adrian",
    "Edgerton",
    "Fort Wayne - Store",
    "Kendallville",
    "Cromwell",
    "Delton",
    "Schoolcraft",
    "Shipshewana",
  ];
  const westernBranches = [
    "Roseland",
    "Elkhart",
    "Three Oaks",
    "Coloma",
    "Mishawaka",
    "Eau Claire",
    "Granger",
    "LaPorte",
  ];

  fetch("/api/getUserID")
    .then((response) => response.json())
    .then((responseJson) => {
      var array = [];
      var arrayLength = responseJson.recordset.length;
      for (var i = 0; i < arrayLength; i++) {
        switch (branch) {
          case "Eastern":
            if (
              checkJobTitlesWebLeads(
                responseJson.recordset[i].JobTitle,
                responseJson.recordset[i].Name
              ) &&
              easternBranches.includes(responseJson.recordset[i].Branch)
            ) {
              array.push(responseJson.recordset[i].UserID);
            }
            break;
          case "Western":
            if (
              checkJobTitlesWebLeads(
                responseJson.recordset[i].JobTitle,
                responseJson.recordset[i].Name
              ) &&
              westernBranches.includes(responseJson.recordset[i].Branch)
            ) {
              array.push(responseJson.recordset[i].UserID);
            }
            break;
          default:
            if (
              (checkJobTitlesWebLeads(
                responseJson.recordset[i].JobTitle,
                responseJson.recordset[i].Name
              ) &&
                responseJson.recordset[i].Branch === branch) ||
              responseJson.recordset[i].Name === "SCOTT BUNKELMAN" ||
              responseJson.recordset[i].Name === "ASHLEY SMITTENDORF"
            ) {
              array.push(responseJson.recordset[i].UserID);
            }
            break;
        }
      }

      const keyString = array.join(","); // Convert array to comma-separated string

      return fetch(`/api/profile/node/msauth2node?users=${keyString}`)
        .then((response) => response.json())
        .then((responseJson) => {
          let salesTeam = [{ userID: "ALL", name: "ALL", id: "None" }];

          responseJson.map((item) => {
            salesTeam.push(item);
          });
          setter(salesTeam);
        })
        .catch((error) => {
          console.error(error);
        });
    })
    .catch((error) => {
      //console.error(error);
    });
};

export const getUserBranch = (user, setter) => {
  return fetch("/api/getUserID")
    .then((response) => response.json())

    .then((responseJson) => {
      var array = [];

      var arrayLength = responseJson.recordset.length;

      for (var i = 0; i < arrayLength; i++) {
        if (responseJson.recordset[i].Name === user.name.toUpperCase()) {
          setter(responseJson.recordset[i].Branch);
          return;
        }
      }

      return "No Branch";
    })

    .catch((error) => {
      //console.error(error);
    });
};

export const assignWebLeadManager = async (data) => {
  //Delete ID so Mongo is happy. (Prevents trying to overwrite the existing _id which will crash Mongo)

  var data = JSON.stringify(data);

  const rawResponse = await fetch("/api/leads/assignManager", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();
};

export const assignWebLeadSalesRep = async (data) => {
  //Delete ID so Mongo is happy. (Prevents trying to overwrite the existing _id which will crash Mongo)

  var data = JSON.stringify(data);

  const rawResponse = await fetch("/api/leads/assignSalesRep", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();
};

export const sendWebLeadNotification = async (id, from, to) => {
  //Delete ID so Mongo is happy. (Prevents trying to overwrite the existing _id which will crash Mongo)

  var data = JSON.stringify({
    id: id,
    from: from,
    to: to,
  });

  const rawResponse = await fetch("/api/leads/sendNotification", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();
};

export const addChange = async (data) => {
  var data = JSON.stringify(data);

  const rawResponse = await fetch("/api/changelog/add", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  });
  const content = await rawResponse.json();
};
